import styled from '@emotion/styled';
import { Col } from 'react-flexbox-grid';


const AutoCol = styled(Col)`
    margin: auto;
`;

export default AutoCol;
